import React from 'react';
import { Modal } from '../../../../UiKit';
import { InfoStrip } from './OrderTagDetailsModal';

const DetailsComponent = ({ tagInfo }) => {
  return (
    <div className='tw-w-full tw-flex tw-flex-col tw-gap-2'>
      {tagInfo?.data.map((elements, index) => (
        <div
          className='tw-border tw-border-solid tw-border-grey-200 tw-rounded-lg tw-bg-white'
          key={index}
        >
          <div className='tw-flex tw-flex-col tw-gap-4 tw-p-4'>
            {elements.map((info) => {
              if (!info) return null;
              return (
                <InfoStrip
                  key={info.key}
                  title={info.key}
                  value={`${info.value}`}
                  isId={false}
                />
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export const UserTagDetailsModal = ({ tagInfo, handleClose }) => {
  if (!tagInfo) return null;
  return (
    <Modal
      isVisible
      type={window.dashboard.mode == 'smartplug' ? 'large' : 'medium'}
      title={tagInfo?.title}
      maxHeight='60vh'
      handleClose={handleClose}
      component={<DetailsComponent tagInfo={tagInfo} />}
    />
  );
};
